import nl from './translations/nl';
import en from './translations/en';

export default {
  nl,
  en
};